import { render, staticRenderFns } from "./index.vue?vue&type=template&id=463d542e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Preloader: require('/opt/buildhome/repo/components/global/Preloader.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
